import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import { Noticia } from '../../models/noticia.model';
import { NoticiasService } from '../../services/noticias.service';
import { DataNoticiaPipe } from '../data-noticia.pipe';

@Component({
  selector: 'app-noticia-card',
  templateUrl: './noticia-card.component.html',
  styleUrls: ['./noticia-card.component.css'],
  imports: [NgOptimizedImage, RouterLink, LucideModule, DataNoticiaPipe],
})
export class NoticiaCardComponent {
  private readonly noticiasService = inject(NoticiasService);

  readonly noticia = input.required<Noticia>();

  readonly rota = computed(() => this.noticiasService.rota(this.noticia()));
}
